import ProductSlideShow from './ProductSlideShow';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

ProductSlideShow.schema = schema;
ProductSlideShow.defaultProps = getEmptyDefaultProps(schema.propsSchema);

export default ProductSlideShow;
